<template>
	<div class="w-100 mb-3 amelipro-disclosure">
		<AmeliproBtn
			:aria-controls="id"
			:aria-expanded="isOpen === true ? 'true' : 'false'"
			class="text-none amelipro-disclosure__btn"
			hover-underline
			text
			type="button"
			@click="opened = !opened"
		>
			{{ title }}

			<template
				v-if="!opened"
				#icon
			>
				{{ mdiChevronDown }}
			</template>

			<template
				v-else
				#icon
			>
				{{ mdiChevronUp }}
			</template>
		</AmeliproBtn>

		<div
			v-show="opened === true"
			:id="id"
			class="amelipro-disclosure__content"
		>
			<slot />
		</div>
	</div>
</template>

<script setup lang="ts">
	import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
	import AmeliproBtn from '../AmeliproBtn/AmeliproBtn.vue';
	import { ref } from 'vue';

	const props = defineProps({
		id: {
			type: String,
			required: true,
		},
		isOpen: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			required: true,
		},
	});

	const opened = ref(props.isOpen);
</script>

<style lang="scss" scoped>
	.accordion-btn {
		padding: 0;
		background-color: transparent;
		border: 0;

		&:focus {
			outline: 1px dotted $ap-grey-darken1;
		}
	}
</style>
